/** Cantidades de acciones: sin decimales si es entero; si no, hasta maxFractionDigits. */
// "de-DE" y no "es-ES": mismo formato (1.234,5) pero agrupa también los miles de 4 cifras (es-ES deja "1234").
export function formatShareAmountEs(
  value: number | null | undefined,
  maxFractionDigits = 4
): string {
  if (value === null || value === undefined) return '';
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  return n.toLocaleString('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxFractionDigits,
    useGrouping: true
  });
}
